import { openNotificationPopup } from "state/application/applicationSlice";
import { addTask } from "state/tasks/tasksSlice";

export function handleFileUpload(
  mutationFunction,
  communityId,
  dispatch,
  taskType = null,
  groupTask = false
) {
  return async (e) => {
    const { files } = e.currentTarget;
    if (!files || files.length === 0) {
      e.target.value = "";
      return "No file";
    }

    const uploads = Array.from(files).map(async (file) => {
      try {
        const response = await mutationFunction({ file, communityId }).unwrap();

        if (taskType && response.task_id) {
          dispatch(addTask({ id: response.task_id, type: taskType, groupTask }));
          return;
        }

        const responseMessage = typeof response === "string" ? response : response.message;
        dispatch(openNotificationPopup({ notification: responseMessage, type: "success" }));
      } catch (err) {
        dispatch(openNotificationPopup({ notification: err, type: "error" }));
      }
    });

    await Promise.all(uploads);
    e.target.value = "";
    return null;
  };
}

export function handleStartTask(
  mutationFunction,
  parameters,
  dispatch,
  taskType = null,
  groupTask = false
) {
  return async () => {
    try {
      const response = await mutationFunction(parameters).unwrap();

      if (taskType && response.task_id) {
        return dispatch(addTask({ id: response.task_id, type: taskType, groupTask }));
      }

      let responseMessage;
      if (typeof response === "string") {
        responseMessage = response;
      } else {
        responseMessage = response.message;
      }
      return dispatch(openNotificationPopup({ notification: responseMessage, type: "success" }));
    } catch (err) {
      return dispatch(openNotificationPopup({ notification: err, type: "error" }));
    }
  };
}

export default {
  handleFileUpload,
  handleStartTask,
};
